

import React  from 'react';
import {GridWrap, ListWrap, Elements} from "./helpers" 


export const AboutDescription = function({data, index, widgetType, device}) {
    return <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} classType="nitin"/>
                <Elements row={data.elements.summary} id={"summary"} device={device} /> 
            </div>
        </div>
    </div>
}

export const AboutTeams = function({data, index, widgetType, mode, device}) { 
    // console.log("device", device) 
    let teamMembers = "" 
    let cl = "g-4 align-items-start justify-content-center"
    if(device === "mobile"){
        cl = "g-4 align-items-start justify-content-start"
    }
    if(data.elements.teamMembers){ 
        teamMembers = data.elements.teamMembers.items.map(function(v, i){    
            return <GridWrap data={v} key={'key-' + v.gridId + i} id="teamMembers" mode={mode} device={device}>
                 <div className="row"> 
                        <div className="col-12 col-md-12"><Elements row={v.banner} id={"banner"} device={device} />  </div> 
                        <div className="col-12 col-md-12">
                            <div className="card-body p-0">
                                <Elements row={v.memberPosition} id={"memberPosition"} device={device} mode={mode} />
                                <Elements row={v.memberName} id={"memberName"} device={device} mode={mode}  />
                                <Elements row={v.memberSummary} id={"memberSummary"} device={device} mode={mode} /> 
                                <Elements row={v.memberSocialInfo} id={"memberSocialInfo"} device={device} mode={mode} />
                            </div>
                        </div>
                </div> 
        </GridWrap>    
        }) 
        teamMembers = <ListWrap data={data.elements.teamMembers} grid={true} mode={mode} className={cl}>
            {teamMembers}
        </ListWrap>
    }

    return  <div className="container-fluid p-0 position-relative">
            <div className="row">
                <div className="col-12">
                    <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
                </div>
            </div> 
            {teamMembers} 
        </div>
}

export const AboutTeamsLeft = function({data, index, widgetType, mode, device}) {   
    let teamMembers = "" 
    if(data.elements.teamMembers){ 
        teamMembers = data.elements.teamMembers.items.map(function(v, i){    
            return <GridWrap data={v} key={'key-' + v.gridId + i} id="teamMembers" mode={mode} device={device}>
                 <div className="row m-0"> 
                        <div className="col-4 col-md-5 px-0"><Elements row={v.banner} id={"banner"} device={device} mode={mode} />  </div> 
                        <div className="col-8 col-md-7 px-0">
                            <div className="card-body p-0 p-lg-0">
                                <Elements row={v.memberPosition} id={"memberPosition"} device={device} mode={mode} />
                                <Elements row={v.memberName} id={"memberName"} device={device} mode={mode} />
                                <Elements row={v.memberSummary} id={"memberSummary"} device={device} mode={mode} /> 
                                <Elements row={v.memberSocialInfo} id={"memberSocialInfo"} device={device} mode={mode} />
                            </div>
                        </div>
                </div> 
        </GridWrap>    
        }) 
        
        let cl = "align-items-start justify-content-center"
        if(device === "mobile"){
            cl = "align-items-start justify-content-start"
        }
        teamMembers = <ListWrap data={data.elements.teamMembers}>
            {teamMembers}
        </ListWrap>
    }

    return  <div className="container-fluid p-0 position-relative">
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
            </div>
        </div> 
        {teamMembers} 
    </div>
}

export const AboutTeamsRight = function({data, index, widgetType, mode, device}) {   
    let teamMembers = "" 
    // console.log("data.elements.teamMembers-----", data)
    if(data.elements.teamMembers){ 
        teamMembers = data.elements.teamMembers.items.map(function(v, i){    
            return <GridWrap data={v} key={'key-' + v.gridId + i} id="teamMembers" mode={mode} device={device}>
                 <div className="row flex-row-reverse m-0"> 
                        <div className="col-4 px-0 col-md-5"><Elements row={v.banner} id={"banner"} device={device} mode={mode} />  </div> 
                        <div className="col-8 col-md-7 px-0">
                            <div className="card-body p-0 p-lg-0">
                                <Elements row={v.memberPosition} id={"memberPosition"} device={device} mode={mode} />
                                <Elements row={v.memberName} id={"memberName"} device={device} mode={mode} />
                                <Elements row={v.memberSummary} id={"memberSummary"} device={device} mode={mode} /> 
                                <Elements row={v.memberSocialInfo} id={"memberSocialInfo"} device={device} mode={mode} />
                            </div>
                        </div>
                </div> 
        </GridWrap>    
        }) 
        teamMembers = <ListWrap data={data.elements.teamMembers}>
            {teamMembers}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative">
            <div className="row ">
                <div className="col-12">
                    <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
                </div>
            </div> 
            {teamMembers} 
        </div>
}

export const AboutTeamsZigZag = function({data, index, widgetType, mode, device }) { 
    let teamMembers = "" 
    if(data.elements.teamMembers){ 
        teamMembers = data.elements.teamMembers.items.map(function(v, i){ 
            let flip = ''
            if(i % 2 !== 0){
                flip = 'flex-row-reverse'
            }   
            return <GridWrap data={v} key={'key-' + v.gridId + i} id="teamMembers" mode={mode} device={device}>
                 <div className={`row ${flip} m-0`}> 
                        <div className="col-5 col-md-4 p-0"><Elements row={v.banner} id={"banner"} device={device} mode={mode}  />  </div> 
                        <div className="col-7 col-md-8 p-0">
                            <div className="card-body p-0 p-lg-0">
                                <Elements row={v.memberPosition} id={"memberPosition"} device={device} mode={mode}  />
                                <Elements row={v.memberName} id={"memberName"} device={device} mode={mode} />
                                <Elements row={v.memberSummary} id={"memberSummary"} device={device} mode={mode}  /> 
                                <Elements row={v.memberSocialInfo} id={"memberSocialInfo"} device={device} mode={mode} />
                            </div>
                        </div>
                </div>
                <div className={`row d-none d-md-none d-lg-none ${flip}`}> 
                        {/* <div className="col-12 col-md-3"><Elements row={v.banner} id={"banner"} />  </div>  */}
                        <div className="col-12">
                            <Elements row={v.banner} id={"banner"} device={device} />
                            <div>
                                <Elements row={v.memberPosition} id={"memberPosition"} device={device} mode={mode} />
                                <Elements row={v.memberName} id={"memberName"} device={device} mode={mode} />
                                <Elements row={v.memberSummary} id={"memberSummary"} device={device} mode={mode} /> 
                                <Elements row={v.memberSocialInfo} id={"memberSocialInfo"} device={device} mode={mode} />
                            </div>
                        </div>
                </div> 
        </GridWrap>    
        })  
        teamMembers = <ListWrap data={data.elements.teamMembers}>
            {teamMembers}
        </ListWrap>
    }

    return  <div className="container-fluid p-0 position-relative">
            <div className="row">
                <div className="col-12">
                    <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
                </div>
            </div> 
            {teamMembers} 
        </div>
} 
 
export const BusinessHours = function({data, index, widgetType, device, mode}) {   
    // console.log("BusinessHours", data)
    return <div className="container-fluid p-0 position-relative">
            <div className="row">
                <div className="col-12">
                     <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} /> 
                     <ListWrap data={data.elements.businessHours}>
                        <Elements row={data.elements.businessHours} root={data} id={"businessHours"} device={device} mode={mode} />
                    </ListWrap>
                    
                </div>
            </div>
        </div> 
}